<!--
	@name app-air-academy-erc
	@description Air Academy page
	@date 2020/02/21
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<common-structure-section :header-class="'info white--text'">
			<template #header>
				<slot>
					Factfind Learning Programme
					<v-chip color="accent" label small class="black--text" style="position: absolute; top: -8px; right: -8px">
						Exclusive
					</v-chip>
				</slot>
			</template>

			<template #body>
				<p class="text-body-2 mb-0">
                    Developed in partnership with the Equity Release Council and LIBF, this programme equips you with the skills and knowledge to conduct effective factfinds, setting best practice standards in the evolving later life lending market.
				</p>
				<app-air-academy-training-webinar-item class="mt-4" :item="testimonial" @play-video="playVideo" />
				<app-dialog-video-player ref="videoDialog" />
			</template>
		</common-structure-section>
	</div>
</template>

<script>
	import CommonStructureSection from '@/component/common/structure/section';
	import AppAirAcademyTrainingWebinarItem from '@/component/app/air-academy/training/webinar-item';
	import AppDialogVideoPlayer from '@/component/app/dialog/video-player';

	export default {
		name: 'app-air-academy-erc',

		components: {
			CommonStructureSection,
            AppAirAcademyTrainingWebinarItem,
            AppDialogVideoPlayer
		},

		data() {
			return {};
		},

		computed: {
            testimonial() {
				return {
					name: 'Factfind Learning Programme',
					image: `${process.env.VUE_APP_S3_AIR_ASSETS_URL}/manager_documents/91b499d7-577e-458b-b725-785cdb7f0892.png`,
                    //imageContain: true,
					mimetype: 'video/mp4',
					hideStatus: true,
					//fixedHeight: true,
					id_course: 332,
					item_slug: 'factfind-learning-programme'
				};
			}
		},

		created() {},

		methods: {
            playVideo() {
				this.$refs.videoDialog.open(`https://player.vimeo.com/video/1070257492?autoplay=1`, true);
			}
        }
	};
</script>

<style lang="scss" scoped>
</style>